define('shared/initializer/form/adapters/Login',[
    '$',
    '../constants',
    './Bootstrap3',
    './mixins/ProtocolGuarantee',
    './mixins/LabelFloatable',
    './mixins/Submittable',
    './mixins/EnterToSubmit',
    './mixins/InputValuePersistable',
    './mixins/InputValueRecoverable',
    './mixins/LoginErrorVisible',
    './mixins/ThrobberOnBeforeSubmit',
    './mixins/ReCaptcha',
    './mixins/HCaptcha',
    'shared/lib/ctor',
    'shared/util/dispatchers/FormDataDispatcher',
    './mixins/fields/Password',
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/util/state',
    'shared/my/cmus',
    'shared/page/partner'
    ],
function (
    $,
    constants,
    Bootstrap3Adapter,
    ProtocolGuarantee,
    LabelFloatable,
    Submittable,
    EnterToSubmit,
    InputValuePersistable,
    InputValueRecoverable,
    LoginErrorVisible,
    ThrobberOnBeforeSubmit,
    ReCaptcha,
    HCaptcha,
    ctor,
    FormDataDispatcher,
    Password,
    RSVP,
    URI,
    state,
    getCMus,
    getPartner
) {
    'use strict';

    var defaultRedirectUrl = 
        '/school/course/currentcourse/handler.aspx?entry=true';

    var Ctor = ctor(function() {
        var me = this;

        me.base.apply(me, arguments);
        me.mixin(
            LoginErrorVisible,
            ProtocolGuarantee,
            LabelFloatable,
            ThrobberOnBeforeSubmit,
            ReCaptcha,
            HCaptcha,
            Submittable,
            EnterToSubmit,
            Password,
            InputValuePersistable,
            InputValueRecoverable
        );

    }).inherit(Bootstrap3Adapter);

    Ctor.setupLoginForm = function($form) {
        var refererUrl = window.location.href;
        var loginTargetHost = window.location.host;
        var onErrorUrl = '';
        var uriCurrent = new URI(window.location.href);


        if(/\.ef\.ru$/i.test(window.location.host)){
            loginTargetHost = 'qa-englishlive.ef.com';
            if(/^www\.ef\.ru$/i.test(window.location.host)){
                loginTargetHost = 'englishlive.ef.com';
            }

            var ruLoginHandlerPath = 'https://' + loginTargetHost + 
                $form.attr('action');
            $form.attr('action', ruLoginHandlerPath);

            refererUrl = uriCurrent
                .host(loginTargetHost).toString();
            onErrorUrl = uriCurrent
                .setQuery('auth', 'false').toString();
        }

        var dispatcher = new FormDataDispatcher($form);
        return dispatcher.dispatch(
            {
                items:
                {
                    'partner':
                    {
                        allowUndefined: true,
                        sources:
                            [{
                                type: 'state',
                                key: 'session.partner_code'
                            }],
                        targets:
                            [{
                                type: 'form',
                                key: 'p'
                            }]
                    },
                    'login.id':
                    {
                        allowUndefined: true,
                        sources:
                            [{
                                type: 'query',
                                key: 'email'
                            }],
                        targets:
                            [{
                                type: 'form',
                                key: 'UserName'
                            }]
                    },
                    'referer':
                    {
                        allowUndefined: true,
                        sources:
                            [{
                                retrieve: function() {
                                    return RSVP.resolve(refererUrl);
                                }
                            }],
                        targets:
                            [{
                                type: 'form',
                                key: 'referer'
                            }]
                    },
                    'onsuccess':
                    {
                        sources:
                            [{
                                type: 'query',
                                key: 'returnurl',
                                caseSensitive: false,
                                format:['pathname', 'search', 'hash']
                            }, 
                            {
                                retrieve: function() {
                                    var onSuccessInForm = 
                                        $form
                                        .find(
                                            '[name="' + 
                                            constants.FIELD.OnSuccessUrl + 
                                            '"]'
                                        ).val();
                                    if(onSuccessInForm){
                                        return RSVP.resolve(onSuccessInForm);
                                    }
                                    else{
                                        return RSVP.resolve(null);
                                    }
                                }
                            },
                            {
                                retrieve: function() {
                                    return RSVP.resolve(
                                        'https://' + 
                                        loginTargetHost + 
                                        defaultRedirectUrl
                                    );
                                }
                            }],
                        targets:
                            [{
                                type: 'form',
                                autoCreation: true
                            }]
                    },
                    'onerror':
                    {
                        sources:
                            [{
                                retrieve: function() {
                                    return RSVP.resolve(onErrorUrl);
                                }
                            }],
                        targets:
                            [{
                                type: 'form'
                            }]
                    }
                }
            });
    };

    var p = Ctor.prototype;
    p.doPageLoad = function() {
        var me = this;
        var partnerCode = '';

        return RSVP.all([getPartner(), getCMus()])
            .then(function(values){
                partnerCode = values[0];
                if( partnerCode == null ) {
                    partnerCode = '';
                }

                partnerCode = partnerCode.toLowerCase();
                if(partnerCode === 'webd'){
                    defaultRedirectUrl = '/signup/profile/b2c';
                }

                var cmus = values[1];
                if(cmus && cmus.length > 0){
                    window.location.href = defaultRedirectUrl;
                }
            })
            .then(function(){
                return Ctor.setupLoginForm(me.$form);
            });
        };

    return Ctor;
});

